import { render, staticRenderFns } from "./OLoyaltyPoints.vue?vue&type=template&id=34efb06a&"
import script from "./OLoyaltyPoints.vue?vue&type=script&lang=js&"
export * from "./OLoyaltyPoints.vue?vue&type=script&lang=js&"
import style0 from "./OLoyaltyPoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports